module.exports = __webpack_public_path__ + "img/flamethrower-explosion.6e5bea3d.png";